<template>
  <div class="select-box" v-clickoutside="closeEvent">
    <div class="select-box-container"  @click="vOpen">
      <span
        class="selected-value"
      >{{selected[this.$props.itemoption[1]] || this.$props.placeholder}}</span>
      <span class="input-clear" @click="vReinit"><i class="material-icons">close</i></span>
      <div class="arrow-down" v-bind:class="{ rotate: opened }">
        <img src="../../assets/img/general/arrow-down.png" />
      </div>
    </div>
    <span class="input-error" v-if="activate_required">{{$_('field_required')}}</span>
    <div class="select-box-dropdown" v-if="opened">
      <div class="search-dropdown" v-if="search">
        <input
          type="text"
          placeholder="Rechercher..."
          v-model="selectFilter"
          class="search-field"
          @keyup="vFilter($event)"
        />
      </div>
      <ul>
        <li
          @click="vSelected(item)"
          :class="item.activate === 0 ? 'disabled':'' "
          v-for="(item, index) in dataDropdown"
          :key="index"
        >{{item[itemoption[1]]}}</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      reset: false,
      selected: Object,
      opened: false,
      load_preselected: false,
      selectFilter: "",
      activate_required: false,
    };
  },
  directives: {
    clickoutside: {
      bind: function(el, binding, vnode) {
        el.clickOutsideEvent = function(event) {
          if (!(el == event.target || el.contains(event.target)) && event.target.className !== "search-field") {
            vnode.context[binding.expression](event);
            vnode.context.opened = false;
          }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
        document.body.addEventListener("touchstart", el.clickOutsideEvent);
        document.body.addEventListener("touchend", el.clickOutsideEvent);
        document.body.addEventListener("touchcancel", el.clickOutsideEvent);
      },
      unbind: function(el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
        document.body.removeEventListener("touchstart", el.clickOutsideEvent);
        document.body.addEventListener("touchend", el.clickOutsideEvent);
        document.body.addEventListener("touchcancel", el.clickOutsideEvent);
      },
      stopProp(event) {
        event.stopPropagation();
      }
    }
  },
  props: {
    data: {},
    placeholder: {
      default: "Veuillez sélectionner une option",
      type: String
    },
    resetselect: {
      default: false,
      type: Boolean
    },
    itemoption: {
      default: () => ["id", "libelle"],
      type: Array
    },
    preselected: {
      type: String
    },
    search: {
      type: Boolean,
      default: false
    },
    immediate: {
      type: Boolean,
      default: false
    },
    selectvalue: {
      type: Object,
      default: () => {}
    },
    required: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    getData() {
      return this.$props.data;
    },
    dataDropdown() {
      var filtered = this.$props.data;

      if (this.selectFilter === "" || this.$props.search === false) {
        return filtered;
      }

      let searchOption =
        this.$props.itemoption[1] !== undefined
          ? this.$props.itemoption[1]
          : this.$props.itemoption[0];

      filtered = filtered.filter(record =>
        `${record[searchOption].toString().toLowerCase()}`.startsWith(
          this.selectFilter.toLowerCase()
        )
      );

      return filtered;
    }
  },
  methods: {
    vOpen() {
      this.opened = !this.opened;
    },
    vSelected(item) {
      this.opened = false;
      this.selected = item;

      this.$emit("select-change", {
        item: item[this.$props.itemoption[0]],
        activate: item.activate
      });
    },
    vReinit() {
      this.vSelected({});
    },
    closeEvent() {},
    vFilter() {}
  },
  watch: {
    resetselect: {
      immediate: true,
      handler(val) {
        if (val === true) {
          this.vSelected({
            [this.$props.itemoption[0]]: '', 
            [this.$props.itemoption[1]]: '',
          })
          this.opened = false;
        }
      }
    },
    preselected: {
      immediate: true,
      handler() {
        if(this.data !== undefined) {
          this.data.map( item => {
            if(item[this.$props.itemoption[0]] == this.$props.preselected) {
              this.vSelected(item);
            }
          })
        }
      }
    },
    selectvalue: {
      handler(val) {
        // this.data.map( item => {
        //   // if(item[this.$props.itemoption[0]] == val.id) {}
        // })
      },
      deep: true
    },
    getData() {
      if(this.$props.preselected !== undefined) {
        if (this.$props.data !== undefined && Array.isArray(this.$props.data)) {
          this.$props.data.map( item => {
            if (item[this.$props.itemoption[0]] == this.$props.preselected) {
              this.vSelected(item);
            }
          });
        }
      }
    },
    data: {
      immediate: true,
      handler(aVal) {
        if (aVal !== undefined && aVal.length === 1 && Object.keys(this.selected).length === 0) {
          this.vSelected(aVal[0]);
        }
      }
    },
    // required(val) {
    //   if(val && this.selected[this.$props.itemoption[0]] !== undefined && ) {
    //     this.activate_required = true;
    //   } else {
    //     this.activate_required = false;
    //   }
    // }
  }
};
</script>

<style scoped>
.select-box {
  min-width: 200px;
  position: relative;
}
.select-box-container {
  border: solid 1px #e9e9e9;
  padding: 9px 20px;
  background-color: #fff;
  display: flex;
  text-align: left;
}
.select-box-container .selected-value {
  flex: 1;
}
.select-box-container:hover {
  cursor: pointer;
}
.select-box-container span {
  font-size: var(--fz-md);
}
.select-box-container .arrow-down img {
  width: 12px;
}
.select-value {
  flex: 1;
}
.select-box-dropdown {
  border-bottom: solid 1px #e9e9e9;
  border-left: solid 1px #e9e9e9;
  border-right: solid 1px #e9e9e9;
  background-color: #fff;
  position: absolute;
  width: 100%;
  z-index: 100;
  max-height: 211px;
  overflow-y: scroll;
}
.select-box-dropdown ul li {
  list-style-type: none;
  font-size: var(--fz-md);
  padding: 9px 20px;
}
.select-box-dropdown ul li.disabled {
  background-color: #cecece;
}
.select-box-dropdown ul li.disabled:hover {
  background-color: #cecece;
}
.select-box-dropdown ul li:hover {
  cursor: pointer;
  background-color: #e9e9e9;
}
.arrow-down img {
  transition: all 0.2s;
}
.rotate img {
  transform: rotate(180deg);
}
.search-dropdown input {
  border-top: none;
  border-left: none;
  border-right: none;
  width: 90%;
  min-width: 0;
  margin: auto;
  display: block;
}
.input-clear {
  position: absolute;
  right: 40px;
  background-color: #cacaca;
  width: 20px;
  height: 20px;
  text-align: center;
  border-radius: 50%;
  transition: all .3s;
}
.input-clear:hover {
  cursor: pointer;
  background-color: #989898;
}
.input-clear i {
  font-size: 0.9rem;
  color: #fff;
}
</style>